import { createApp } from '@app/adapters/create-app'

import BeamerChangelogBanner from './../sections/changelog/components/beamer-changelog-banner.vue'
import BeamerBridge from './../sections/changelog/beamer-bridge'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='changelog-banner']").each(function () {
    if (!this.dataset.changelogPostsUrl) return

    const beamerChangelogBannerApp = createApp(BeamerChangelogBanner)

    beamerChangelogBannerApp.use(
      BeamerBridge({
        postsUrl: this.dataset.changelogPostsUrl,
        segment: this.dataset.changelogSegment,
        locale: this.dataset.changelogLocale,
        changelogUrl: this.dataset.changelogReadMoreUrl,
      })
    )

    beamerChangelogBannerApp.mount(this)
  })
})
